import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useViewModel } from "./useViewModel";
import { PatientsViewModel } from "./PatientsViewModel";
import { PatientsContentContainer, PatientsParent, PatientsRecentContainer, PatientsRowChevron, PatientsSearchContainer, PatientsSubtitle, PatientsTitle, } from "./PatientsView.styles";
import { HXDesktopSearchTextField } from "./HXDesktopSearchTextField";
import { HXDataGrid } from "./HXDataGrid";
import { filterFalse } from "healthex-common/utils";
import { SmallText } from "./HXDesktopPage.styles";
import { format } from "date-fns";
import { PatientsSearchTipsDesktopFooter } from "./HealthSystemFooter";
import { NOT_LOADED } from "../Infra/RemoteData";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { FlexRow } from "./common.styles";
import { HXButton } from "./HXButton";
import SearchIcon from "@mui/icons-material/Search";
import { addDisplayName } from "../Infra/display-name";
export const PatientsView = observer((props) => {
    const model = useViewModel(PatientsViewModel, props.container);
    return (_jsxs(PatientsParent, { children: [_jsxs(PatientsContentContainer, { children: [_jsx(PatientsTitle, { children: "Patients" }), _jsxs(PatientsSearchContainer, { children: [_jsx(PatientsSubtitle, { children: "Find a patient to start guided consent" }), _jsxs(FlexRow, { gap: 16, children: [_jsx(HXDesktopSearchTextField, { grow: true, placeholder: "Search for a patient by MRN", searchText: model.searchText, updateSearchText: (text) => {
                                            model.updateSearchText(text);
                                        }, onEnterPressed: () => model.search(), errorText: model.searchErrorText }), _jsx(HXButton, { secondary: true, startIcon: _jsx(SearchIcon, {}), onClick: () => model.search(), children: "Search" })] })] }), model.showRecentPatientsTable && model.recentPatients !== NOT_LOADED && (_jsxs(PatientsRecentContainer, { children: [_jsx(PatientsSubtitle, { children: "Recently searched patients" }), _jsx(HXDataGrid, { rows: model.recentPatients, columns: columns(), getRowId: (patient) => patient.mrn, showPagination: false, onRowClick: (params) => model.onRecentPatientRowClick(params.row) })] })), model.showSpinner && _jsx(LoadingPlaceholder, { center: true, w: 10, h: 60 })] }), model.showFooter && _jsx(PatientsSearchTipsDesktopFooter, {})] }));
    function columns() {
        return filterFalse([
            { field: "mrn", headerName: "MRN", flex: 1 },
            {
                field: "fullName",
                headerName: "Patient name",
                flex: 1,
                renderCell: (params) => {
                    if (params.value === null || params.value === undefined)
                        return "-";
                    return _jsx(SmallText, { children: params.value });
                },
            },
            {
                field: "birthDate",
                headerName: "Date of birth",
                flex: 1,
                renderCell: (params) => {
                    if (params.value === null || params.value === undefined)
                        return "-";
                    return _jsx(SmallText, { children: format(params.value, "LLL dd, yyyy") });
                },
            },
            {
                field: "lastAccessed",
                headerName: "Last accessed",
                flex: 1,
                renderCell: (params) => {
                    if (params.value === null || params.value === undefined)
                        return "-";
                    return _jsx(SmallText, { children: format(params.value, "LLL dd, yyyy") });
                },
            },
            {
                field: "chevron",
                headerName: "",
                width: 88,
                sortable: false,
                renderCell: () => {
                    return _jsx(PatientsRowChevron, {});
                },
            },
        ]);
    }
});
addDisplayName(PatientsView, "PatientsView");
